import {BehaviorSubject, Subject} from "rxjs";
import {inject, Injectable} from '@angular/core';
import {DataService} from '@serv/data.service';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({
  providedIn: 'root'
})

export class UtilsVarsComponentLlm {
  //Injectables
  private _console = inject(Tools_aiConsoleService);
  private transcript = new BehaviorSubject<string>('');
  transcript$= this.transcript.asObservable();

  constructor(private dataService: DataService) {
  }

  /**
   * Obtiene información del usuario relevante para la interacción.
   * @returns Un objeto con el nombre y el sexo del usuario.
   */
  async getUserDataRelevant(): Promise<{ name: string; sexo: string | undefined }> {
    return new Promise((resolve) => {
      this.dataService.user$.subscribe({
        next: (data) => {
          let sexo: string | undefined = undefined;
          if (data.gender === 1) {
            sexo = 'male';
          } else if (data.gender === 2) {
            sexo = 'female';
          }

          resolve({
            name: data.firstName,
            sexo: sexo,
          });
        },
        error: (err) => {
          this._console.error('Error: ', err);
        },
        complete: () => {},
      });
    });
  }


  /**
   * Obtém a hora atual e retorna uma saudação (Bom dia, Boa tarde, Boa noite).
   * @returns Uma Promessa que resolve para uma string com o saudação baseado na hora atual.
   * CORREÇÃO: Tipo de retorno de `string` para `Promise<string>`.
   */
  async getSaludoPorHora(): Promise<string> {
    const ahora = new Date();
    const hora = ahora.getHours();

    if (hora >= 5 && hora < 12) {
      return 'Bom dia';
    } else if (hora >= 12 && hora < 19) {
      return 'Boa tarde';
    } else {
      return 'Boa noite';
    }
  }

  /**
   * Obtém a hora atual formatada como HH:MM.
   * @returns Uma Promessa que resolve para uma string com a hora atual.
   * CORREÇÃO: Tipo de retorno de `string` para `Promise<string>`.
   */
  async getHoraActual(): Promise<string> {
    const ahora = new Date();
    const horas = ahora.getHours().toString().padStart(2, '0');
    const minutos = ahora.getMinutes().toString().padStart(2, '0');
    return `${horas}:${minutos}`;
  }


}

//Interfaces

/**
 *Interface definida para manejar los datos que sé enviar al diálogo
 * encargado de selecionar cuando hay items repetidos
 */
export interface PropertiesDialogDataSelect {
  items:{
    id: string;
    name: string;
    descriptor: string;// Alternativa para hablar directamente del item
  }[];
  icon:string;
  nameClass:string;
  references?: {
    positive?: string,
    negative?: string
  }
}
